(function (angular) {
  "use strict";

  angular.module("Toyota").directive("tyAddToWishlistOnQuerystring", [
    "$location",
    "$timeout",
    "Wishlist",
    "DebugLogger",
    "$rootScope",
    function ($location, $timeout, Wishlist, DebugLogger, $rootScope) {
      return {
        scope: true,
        restrict: "A",
        link: function (scope) {
          const ADD_TO_WISHLIST_PARAM_KEY = "add_to_wishlist";
          const MATERIAL_CODE_PARAM_KEY = "material_code";
          const addToWishlistParam =
            $location.search()[ADD_TO_WISHLIST_PARAM_KEY];
          const materialCodeParam = $location.search()[MATERIAL_CODE_PARAM_KEY];

          DebugLogger.log(
            "tyAddToWishlistOnQuerystring",
            "addToWishlistParam: ",
            addToWishlistParam
          );
          DebugLogger.log(
            "tyAddToWishlistOnQuerystring",
            "materialCodeParam: ",
            materialCodeParam
          );

          let authenticationState = null;

          const ensurePaintLoadedThenAddToWishlist = (materialCodeParam) => {
            const materialCode = scope.pricingPage.materialCodePaintLoaded;
            if (scope.pricingPage.materialCodePaintLoaded) {
              DebugLogger.log(
                "tyAddToWishlistOnQuerystring",
                "ensurePaintLoadedThenAddToWishlist - materialCodePaintLoaded found",
                materialCode
              );
              Wishlist.addNewVehicleToWishlist(materialCode);
            } else {
              DebugLogger.log(
                "tyAddToWishlistOnQuerystring",
                "ensurePaintLoadedThenAddToWishlist - waiting for pricing-page-material-code-paint-loaded, anticipating result for",
                materialCodeParam
              );
              const off = $rootScope.$on(
                "pricing-page-material-code-paint-loaded",
                function (e, materialCode) {
                  DebugLogger.log(
                    "tyAddToWishlistOnQuerystring",
                    "waitForPaintDataToCacheThenAddToWishlist - received pricing-page-material-code-paint-loaded for",
                    materialCode
                  );
                  Wishlist.addNewVehicleToWishlist(materialCode);
                  off();
                }
              );
            }
          };

          Wishlist.onAuthenticationStateKnown((e) => {
            DebugLogger.log(
              "tyAddToWishlistOnQuerystring",
              "onAuthenticationStateKnown handler fired with detail:",
              e.detail
            );
            authenticationState = e.detail;
          });

          if (addToWishlistParam === "1" && materialCodeParam) {
            if (authenticationState?.isAuthenticated) {
              ensurePaintLoadedThenAddToWishlist(materialCodeParam);
            } else {
              const off = Wishlist.onAuthenticationStateKnown((e) => {
                ensurePaintLoadedThenAddToWishlist(materialCodeParam);
                off();
              });
            }
          }

          $rootScope.$on(
            "pricing-page-material-code-paint-loaded",
            function (e, materialCode) {
              DebugLogger.log(
                "tyAddToWishlistOnQuerystring",
                "pricing-page-material-code-paint-loaded:",
                materialCode
              );
              scope.pricingPageMaterialCode = materialCode;
            }
          );

          Wishlist.onAddNewVehicleToWishlistSuccess((materialCode) => {
            scope.showOutline = false;
            DebugLogger.log(
              "tyAddToWishlistOnQuerystring",
              "onAddNewVehicleToWishlistSuccess handler fired with materialCode:",
              materialCode
            );
          });
        },
      };
    },
  ]);
})(window.angular);
